// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import SectionHeader from 'components/text/SectionHeader';

class AdminHome extends React.PureComponent {
  render() {
    return (
      <PageContainer flex="center">
        <SectionHeader>Admin Home</SectionHeader>
      </PageContainer>
    );
  }
}

export default AdminHome;



// WEBPACK FOOTER //
// ./src/routes/admin-home/index.js